import { Dialog } from "./Dialog";
import { ThemedButton } from "./Button";

interface AppExitDialogProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const AppExitDialog = ({
  visible,
  onConfirm,
  onCancel,
}: AppExitDialogProps) => {
  return (
    <Dialog visible={visible} onClose={onCancel} persist={false}>
      <div className="text-center p-4">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">
          앱을 종료하시겠습니까?
        </h3>
        <div className="flex gap-3 justify-center">
          <ThemedButton
            onClick={onCancel}
            color="secondary"
            size="md"
            className="flex-1 max-w-[120px]"
          >
            취소
          </ThemedButton>
          <ThemedButton
            onClick={onConfirm}
            color="primary"
            size="md"
            className="flex-1 max-w-[120px]"
          >
            확인
          </ThemedButton>
        </div>
      </div>
    </Dialog>
  );
};
